module.exports = __webpack_public_path__ + "img/geodir-sodexo-testimonial.10d8e29c.png";